@if (selectedUser(); as user) {
    <!-- Step 2: which role for this person. Going back is a footer button, with Cancel. -->
    <div class="d-flex align-items-center mb-4">
        <ms-avatar [identity]="user" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
            [avatarAdditionalAttributes]="avatarAdditionalAttributes" />

        <div class="min-w-0 ms-3">
            <div class="fw-bold text-truncate">{{ user.firstName + ' ' + user.lastName }}</div>
            <small class="text-truncate d-block">{{ user.emailAddress }}</small>
        </div>
    </div>

    <h6 class="mb-3">{{ StaffManagementMessagingConstants.STAFF_CHOOSE_ROLE_PROMPT() }}</h6>

    @if (roleOptions().length > 0) {
        <div class="d-flex flex-column gap-2">
            @for (option of roleOptions(); track option.role) {
                <button type="button" class="ms-selectable-card staff-role-option text-start p-3"
                    (click)="onRoleClicked(option.role)">
                    <div class="fw-semibold">{{ option.role }}</div>
                    @if (option.description) {
                        <div class="text-secondary small">{{ option.description }}</div>
                    }
                </button>
            }
        </div>
    } @else {
        <!-- Reachable now that the list includes users who already hold roles. -->
        <p class="text-secondary mb-0">{{ allRolesHeldMessage() }}</p>
    }
} @else {
    <!-- Step 1: who -->
    <div class="d-flex justify-content-between flex-row flex-wrap gap-3 mb-3" #pickerTop>
        <div class="input-group position-relative">
            <input id="staffUserPickerSearch"
                type="text"
                class="form-control form-control-solid pe-5"
                placeholder="Search by name or email"
                aria-label="Search users"
                [ngModel]="searchTerm()"
                (ngModelChange)="searchTerm.set($event)"
                (keyup.enter)="loadUsers()">

            @if (searchTerm()) {
                <button
                    class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                    type="button"
                    (click)="clearSearch()"
                    aria-label="Clear search">
                    <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.4" size="lg"/>
                </button>
            }

            <div class="input-group-append">
                <button class="btn btn-primary rounded-0 rounded-end" type="button" (click)="loadUsers()">
                    Search
                </button>
            </div>
        </div>

        <div class="align-self-center">
            @if (isLoading && users().length === 0) {
                <span class="placeholder col-8">&nbsp;</span>
            } @else {
                Showing: {{ users().length || 0 }} of {{ totalCount | number }}
            }
        </div>
    </div>

    @if (errorMessage()) {
        <div class="alert alert-danger" role="alert">
            <fa-duotone-icon icon="circle-exclamation" secondaryOpacity="0.4" class="me-2" />
            {{ errorMessage() }}
        </div>
    }

    <div class="table-responsive">
        <table class="table table-hover placeholder-glow">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col" class="d-none d-md-table-cell">Last Login</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                @for (user of displayUsers; track user.userId) {
                    <tr class="align-middle">
                        <td>
                            <div class="d-flex align-items-center">
                                <ms-avatar [identity]="user" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
                                    [avatarAdditionalAttributes]="avatarAdditionalAttributes" [isLoading]="isLoading" />

                                <div class="min-w-0 ms-3">
                                    <div class="fw-bold text-truncate" [class.placeholder]="isLoading"
                                        [msTooltip]="(user.firstName + ' ' + user.lastName).trim()" msTooltipOnlyIfTruncated>
                                        {{ user.firstName + ' ' + user.lastName }}
                                    </div>
                                    <small class="text-truncate d-block" [class.placeholder]="isLoading"
                                        [msTooltip]="user.emailAddress" msTooltipOnlyIfTruncated>{{ user.emailAddress }}</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <span [class.placeholder]="isLoading">
                                {{ user.lastLogin ? ((user.lastLogin + "Z") | date:'MMM dd, yyyy h:mm a') : 'Never' }}
                            </span>
                        </td>
                        <td>
                            @if (isLoading) {
                                <span class="btn btn-primary placeholder col-12">&nbsp;</span>
                            } @else {
                                <button type="button" class="btn btn-primary text-nowrap" (click)="onUserClicked(user)">
                                    Choose Role
                                    <fa-duotone-icon icon="arrow-right" secondaryOpacity="0.4" class="ms-2" />
                                </button>
                            }
                        </td>
                    </tr>
                }
            </tbody>
            <tfoot ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayUsers.length" (jumpToClicked)="jumpToTop()">
            </tfoot>
        </table>
    </div>
}
